var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyMixes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.29 25.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-linejoin:round;}.cls-2{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sounds"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.63,
    y: 8.63,
    width: 21.16,
    height: 16.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.21,13.8a3,3,0,0,1,2.57-1.19,2.83,2.83,0,0,1,1.94,1.71c.69,1.68-.66,3.77-3.32,6.12a1.85,1.85,0,0,1-2.42,0c-2.65-2.35-4-4.41-3.28-6.08a2.88,2.88,0,0,1,1.94-1.78A3.05,3.05,0,0,1,18.21,13.8Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "4.06 20.68 4.06 4.46 23.15 4.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "0.5 16.72 0.5 0.5 19.59 0.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMixes);
export default __webpack_public_path__ + "static/media/my-mixes.cd00e7c08fa4921e2d7ae81c9028cc3a.svg";
export { ForwardRef as ReactComponent };